export default [
    {
        path:'/security', redirect:'login',  component: () => import('@/views/security'), children : [
            {
                path:'/login', component: () => import('@/views/security/login'),meta:{}
            },
            {
                path:'/register', component: () => import('@/views/security/register'),meta:{}
            },
            {
                path:'/forget-password', component: () => import('@/views/security/forget-password'),meta:{}
            },
        ]
    }
]